const ZDANIA3 = [ 
  {
    name: 'Angielski : Subject and object pronouns',
    lang: 'en',
    zdania: [
      {
        pl: 'To jest Jack. Jego mama (mother) jest taka miła',
        de: 'This is Jack. His mother is so kind',
      },
      {
        pl: 'To jest Ann. Jej tata (dad) jest na prawdę zabawny',
        de: 'This is Ann. Her dad is really funny',
      },
      {
        pl: 'Donald i Mike są nauczycielami. Ich studenci są mądrzy',
        de: 'Donald and Mike are teachers. Their students are smart',
      },
      {
        pl: 'Lubię moją rodzinę. Oni są cool',
        de: 'I like my familly. They are cool',
      },
      {
        pl: 'Mam dwie siostry. Ich imiona to Julie i Mary',
        de: 'I have got two sisters. Their names are Julie and Mary',
      },
      {
        pl: 'Czy mozesz mi dać twój długopis, proszę ?',
        de: "Can you give me your pen, please ?",
      },
      {
        pl: 'Patrz na nią. Ona jest taka piękna',
        de: 'Look at her. She is so beautiful',
      },
      {
        pl: 'Ona ma siostrę',
        de: 'She has got a sister',
      },
      {
        pl: 'Patrz na mnie',
        de: 'Look at me',
      },
      {
        pl: 'Tam (dalej ode mnie) jest mój ojciec. Jego imię to Dave',
        de: "That's my father. His name is Dave"
      },
      {
        pl: 'Moi rodzice są cool. Kocham ich',
        de: 'My parents are cool. I love them',
      },
      {
        pl: 'Te jabłka są dla nas',
        de: 'These apples are for us',
      },
      {
        pl: 'Nasz nauczyciel jest przyjazny ',
        de: 'Our teacher is friendly'
      },
      {
        pl: 'Moje imię to Mike',
        de: 'My name is Mike',
      },
      {
        pl: 'Mam 10 lat',
        de: "I'am 10 years old"
      },
      {
        pl: 'Mam duzą rodzinę',
        de: 'I have got a big familly'
      },
      {
        pl: 'Nasza rodzina jest troszcząca się',
        de: 'Our familly is caring'
      },
      {
        pl: 'Ona ma 35 lat',
        de: 'She is 35 years old'
      },
      {
        pl: 'Ona jest doktorem',
        de: 'She is a doctor'
      },
      {
        pl: 'Na prawdę ją kocham',
        de: 'I really love her'
      },
      {
        pl: 'On zawsze mi pomaga z moimim zadaniami domowymi',
        de: 'He always helps me with my homework'
      },
      {
        pl: 'Zawsze opowiadam mu straszne historie',
        de: 'I always tell him scary stories'
      },
      {
        pl: 'Mam kota i psa. Ich imiona to Tom i Spike',
        de: 'I have got a cat and a dog. Their names are Tom and Spike'
      },
      {
        pl: 'Moja mama (mum) dzwoni do mnie',
        de: 'My mum calls me'
      },
      {
        pl: 'Powiedz mi o Twojej rodzinie',
        de: 'Tell me about Your familly'
      },
      {
        pl: 'On jest w pracy',
        de: 'He is at work'
      },
      {
        pl: 'Czy mozesz mi powiedziec Twoj numer telefonu?',
        de: 'Can you tell me your phone number?'
      },
    ]
  } 
]

export {
    ZDANIA3
}